import React from 'react';
import { Smartphone, Monitor, Tablet } from 'lucide-react';
import { cn } from '../../../lib/utils';

const DeviceSelector = ({ 
  value = '', 
  onChange, 
  className = '',
  disabled = false,
  required = false 
}) => {
  const devices = [
    {
      id: 'iphone',
      label: 'iPhone',
      icon: Smartphone,
      description: 'iOS devices'
    },
    {
      id: 'android',
      label: 'Android',
      icon: Smartphone,
      description: 'Android phones'
    }
  ];

  const handleSelect = (deviceId) => {
    if (!disabled) {
      onChange?.(deviceId);
    }
  };

  return (
    <div className={cn("grid grid-cols-2 gap-3", className)}>
      {devices.map((device) => {
        const Icon = device.icon;
        const isSelected = value === device.id;
        
        return (
          <button
            key={device.id}
            type="button"
            onClick={() => handleSelect(device.id)}
            disabled={disabled}
            data-selected={isSelected}
            className={cn(
              "relative flex flex-col items-center justify-center p-4 rounded-lg",
              "border transition-all duration-200",
              "cursor-pointer group",
              "min-h-[100px] sm:min-h-[120px]",
              // Glass morphism style
              "bg-white/10 backdrop-blur-md",
              // Default state
              "border-white/20",
              // Selected state takes priority over hover
              isSelected 
                ? "bg-purple-600/20 border-purple-500/50" 
                : "hover:border-white/30 hover:bg-white/15",
              // Disabled state
              disabled && "opacity-50 cursor-not-allowed",
              // Mobile optimization - ensure good touch targets
              "touch-manipulation"
            )}
            aria-label={`Select ${device.label}`}
            aria-pressed={isSelected}
          >
            <Icon 
              className={cn(
                "h-8 w-8 mb-2 transition-colors",
                isSelected 
                  ? "text-purple-400" 
                  : "text-white/60 group-hover:text-white/80"
              )} 
            />
            <span 
              className={cn(
                "font-medium text-sm",
                isSelected ? "text-white" : "text-white/80"
              )}
            >
              {device.label}
            </span>
            <span 
              className={cn(
                "text-xs mt-1 hidden sm:block",
                isSelected 
                  ? "text-white/70" 
                  : "text-white/60"
              )}
            >
              {device.description}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default DeviceSelector;